var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var WhatsappSvg = /* @__PURE__ */ __name(function WhatsappSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M8.533 12.849c0.308 1.045 0.651 1.93 1.057 2.778l-0.048-0.112c0.627 1.067 1.283 1.988 2.011 2.847l-0.024-0.029c1.901 2.329 4.579 3.96 7.635 4.496l0.076 0.011c0.221 0.048 0.475 0.075 0.735 0.075 1.041 0 1.98-0.436 2.645-1.136l0.001-0.002c1.062-1.049 0.844-2.333-0.444-2.964l-0.516-0.253c-1.88-0.924-1.898-0.938-3.236 0.613-0.167 0.249-0.448 0.411-0.767 0.411-0.19 0-0.366-0.057-0.512-0.156l0.003 0.002c-1.791-0.817-3.26-2.073-4.31-3.634l-0.023-0.037c-0.413-0.604-0.444-1.040 0.116-1.551 0.402-0.286 0.661-0.75 0.661-1.275 0-0.322-0.097-0.62-0.264-0.869l0.004 0.006c-0.217-0.422-0.445-0.945-0.642-1.483l-0.033-0.103c-0.6-1.413-1.92-1.604-2.933-0.418-0.638 0.757-1.062 1.714-1.167 2.765l-0.002 0.021zM1.6 30.369c0.56-2.076 1.067-4.062 1.64-6.027 0.080-0.248 0.126-0.534 0.126-0.83 0-0.463-0.112-0.899-0.311-1.284l0.007 0.016c-2.449-5.476-1.951-10.716 1.862-15.36s8.853-6.271 14.631-4.818 9.36 5.267 10.538 11.040-0.653 10.667-5.293 14.249-9.689 3.942-14.987 1.667c-0.297-0.127-0.643-0.201-1.006-0.201-0.163 0-0.322 0.015-0.477 0.043l0.016-0.002c-2.013 0.418-4 0.92-6.013 1.382-0.2 0.049-0.409 0.067-0.733 0.12z"
  }));
}, "WhatsappSvg");
var WhatsappIcon = /* @__PURE__ */ __name(function WhatsappIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: WhatsappSvg
  }, props));
}, "WhatsappIcon");
export {
  WhatsappIcon
};
